export default "__VITE_ASSET__4Xaj6o8S__"